import { Box } from "@/components/layout/flexbox";
import { CARD_CLASSES } from "@/css/constants";

export default function PrettyBox(props) {
  return (
    <Box
      className={CARD_CLASSES}
      backgroundColor="#FFF"
      py={[3, 3, 3, 24]}
      px={[3, 3, 3, 4]}
      {...props}
    />
  );
}
